import { Reducer } from 'redux'

import { ActionTypes as CitationActionTypes } from '@chegg-wt/core/state/citation/constants'
import {
  FORM_SUBMIT_FAILED,
  WRITING_FORM_SUBMIT_REQUESTED,
  FORM_SUBMIT_SUCCEEDED,
  FORM_SUBMIT_START,
  FORM_SUBMIT_STOP,
} from './constants'
import { FormState } from './types'

export const initialState: FormState = {
  isSubmitting: false,
}

export const formReducer: Reducer<FormState> = (state = initialState, action) => {
  switch (action.type) {
    case CitationActionTypes.CITATION_CREATE:
    case CitationActionTypes.CITATION_UPDATE:
    case WRITING_FORM_SUBMIT_REQUESTED:
    case FORM_SUBMIT_START:
      return {
        ...state,
        isSubmitting: true,
      }
    case CitationActionTypes.CITATION_CREATE_SUCCEEDED:
    case CitationActionTypes.CITATION_CREATE_FAILED:
    case CitationActionTypes.CITATION_UPDATE_SUCCEEDED:
    case CitationActionTypes.CITATION_UPDATE_FAILED:
    case FORM_SUBMIT_SUCCEEDED:
    case FORM_SUBMIT_FAILED:
    case FORM_SUBMIT_STOP:
      return {
        ...state,
        isSubmitting: false,
      }
    default:
      return state
  }
}

export default formReducer
